import ExcelJS from "exceljs";
import ExportMenu from "../../../../Common/ExportMenu/ExportMenu";
import { formattedDate } from "../../../../Common/helper/helpar";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";
import jsPDF from "jspdf"; // Add this for PDF export
import autoTable from "jspdf-autotable";
export const TippingFeeExport = () => {
  const { tippingFeeReportData, } = TippingFeeCalculationStore()

  const totalHMSWTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tonnage) || 0), 0);
  const totalGHMCTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tonnage) || 0), 0);
  const totalTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);
  const totalHMSWTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tipping) || 0), 0);
  const totalGHMCTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tipping) || 0), 0);
  const totalAmount = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Amount) || 0), 0);
  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tipping Fee Calculation Report");

    // Define styles
    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDateStr = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Tipping Fee Calculation Report Generated on: ${formattedDateStr}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add report title
    worksheet.addRow(["", "", "Tipping Fee Calculation Report", ""]);
    worksheet.mergeCells(2, 2, 2, 8);
    worksheet.getCell(2, 2).value = "Tipping Fee Calculation Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Date",
        "HMSW Tonnage",
        "GHMC Tonnage",
        "Total Tonnage",
        "HMSW Tipping Fee",
        "GHMC Tipping Fee",
        "Total Amount",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center", wrapText: true, vertical: "middle" };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F6B1B1" },
            bgColor: { argb: "FFFFFFFF" },
        };
    });

    // Add data rows
    tippingFeeReportData.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            formattedDate(item.transactionDate),
            item.himsW_Tonnage,
            item.ghmC_Tonnage,
            item.total_Tonnage,
            item.himsW_Tipping,
            item.ghmC_Tipping,
            item.total_Amount,
        ]).eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { horizontal: "center" };
        });
    });

    // Add total row
    worksheet.addRow([
        "",
        "Total",
        totalHMSWTonnage,
        totalGHMCTonnage,
        totalTonnage,
        totalHMSWTipping,
        totalGHMCTipping,
        totalAmount,
    ]).eachCell({ includeEmpty: true }, (cell) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
    });

    // Set column widths dynamically
    worksheet.columns = [
        { width: 10 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
        { width: 25 },
    ];

    // Save the workbook to a file
    try {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "TippingFeeCalculationReport.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error generating Excel file:", error);
    }
};

const downloadAsPDF = () => {
  const doc = new jsPDF();
  const tableColumn = ["S.No", "Date", "HMSW Tonnage", "GHMC Tonnage", "Total Tonnage", "HMSW Tipping Fee", "GHMC Tipping Fee", "Total Amount"];
  const tableRows = [];

  tippingFeeReportData.forEach((item, index) => {
      const rowData = [
          index + 1,
          formattedDate(item.transactionDate),
          item.himsW_Tonnage,
          item.ghmC_Tonnage,
          item.total_Tonnage,
          item.himsW_Tipping,
          item.ghmC_Tipping,
          item.total_Amount,
      ];
      tableRows.push(rowData);
  });

  // Add total row
  tableRows.push([
      "",
      "Total",
      totalHMSWTonnage,
      totalGHMCTonnage,
      totalTonnage,
      totalHMSWTipping,
      totalGHMCTipping,
      totalAmount,
  ]);

  // Add title and date (centered)
  const currentDate = new Date();
  const formattedDateStr = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
  const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  const downloadDateTime = `Tipping Fee Calculation Report Generated on: ${formattedDateStr}, ${formattedTime}`;
  const pageWidth = doc.internal.pageSize.width;
  const titleX = pageWidth / 2;
  const dateX = pageWidth / 2;
  // doc.text(downloadDateTime, dateX, 15, { align: "center" });
  doc.text("Tipping Fee Calculation Report", titleX, 25, { align: "center" });

  // Use autoTable with centered text
  autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      theme: "striped",
      headStyles: { halign: "center" }, // Center header text
      styles: { halign: "center" }, // Center all table content
  });

  // Save the PDF
  doc.save("TippingFeeCalculationReport.pdf");
};

  return (
    <>
      <ExportMenu
        items={[
          { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadAsPDF },
          { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadAsExcel },
        ]}
      />
    </>
  );
};
